// extracted by mini-css-extract-plugin
export default {"noSpinners":"Global_noSpinners__fDqWu"};